import React from 'react';
import SubjectCategoryList from '../../components/SubjectCategoryList';

const FavoriteSubjectCategories = () => {
    return <SubjectCategoryList favoritesOnly={true} />;
};

export default FavoriteSubjectCategories;
